import { Component, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
@Component({
    selector: 'testimonial-slider',
    templateUrl: './testimonial-slider.component.html',
    styleUrls: ['./testimonial-slider.component.scss'],
    standalone: false
})
export class TestimonialSliderComponent implements OnInit {
  testimonialList: any;
  slides = [];
  BANNER_QUERY = gql`
  query  {
    testimonials{
      id
      description
      name
      company
      image {
        id
        fileName
        size
        url
      }
    }
    textBanners{
      id
    textMessage
    updatedAt
      }
}
`;
  
  slideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 1,
    "dots": true,
    "arrows": false,
    "infinite": true,
    "loop": true,
    "autoplay": {
      delay: 2000,
    },
    'responsive': [
      { 'breakpoint': 992, 'settings': { 'slidesToShow': 2 } },
      { 'breakpoint': 767, 'settings': { 
        'slidesToShow': 1 ,
        "dots": false,
        "arrows": true,
        "adaptiveHeight":true
      } }
    ]
  };
  
  private query: QueryRef<any>;

  constructor(private apollo: Apollo) { }

  ngOnInit(): void {

    this.query = this.apollo.watchQuery({
      query: this.BANNER_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.testimonialList = result.data.testimonials;
      for (let i = 0; i < this.testimonialList.length; i++) {
        this.slides.push({img: this.testimonialList[i].image.url, testimonialName: this.testimonialList[i].name, companyType: this.testimonialList[i].company, testimonilaMessage: this.testimonialList[i].description})
        
      }
      
    });
  }

}
